<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="StatisticsOverview")
    h1.title Reinigungsübersicht
    .sub-headline Hier können Sie kommende Reinigungen ansehen.

    .calendar-config.margin-top      
      v-date-picker(is-expanded :columns="4" is-range v-model="dateRange")

    //- .button-wrapper.margin-top.right   
    //-   b-button(type="is-light" icon-left="file-excel" disabled) Demnächst verfügbat
    
    //- pre {{cleaningDatesProcessed}}

  .margin-top
    .day(v-for="d in cleaningDatesProcessed.datesProcessed" :style="{background: getColor(d.score / cleaningDatesProcessed.highestScore)}")
      .row.bold
        | {{new Date(d.date).toLocaleDateString("de-DE", dateOptions)}}
      .row
        .room ⊡
        .count {{d.oneRoom}}
      .row
        .room ⊡⊡
        .count {{d.threeRoom}}
      .row
        .room ⊡⊡⊡
        .count {{d.twoRoom}}
      .row
        .room Abreisen
        .count {{d.departures}}
      .row
        .room Wechsel
        .count {{d.changes}}
    p(v-if="cleaningDatesProcessed.datesProcessed.length > 0") Die Farkodierung wird abhängig von dem Gewicht und der Größe der Daten durchgeführt. 1-Raum = 10%, 2-Raum = 15%, 3-Raum = 20%, Abreisen = 5% und Wechsel = 50%.
          
          
</template>

<script>
// import { DateTime } from 'luxon';

export default {
  data() {
    return {
      cleaningDates: [],
      cleaningDatesProcessed: {
        highestRooms: 0,
        highestOneRoom: 0,
        highestTwoRoom: 0,
        highestThreeRoom: 0,
        highestChange: 0,
        highestDeparture: 0,
        datesProcessed: []
      },
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      dateOptions: {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        weekday: "short",
      }
    }
  },
  watch: {
    dateRange: {
      async handler(){
        const loadingComponent = this.$buefy.loading.open();
        this.cleaningDates = await this.$store.dispatch("rentObjectBookings/findCleaningDates", this.dateRange);
        this.cleaningDatesProcessed = this.processDates(this.cleaningDates);
        loadingComponent.close();
      },
      deep: true
    }
  },
  methods: {
    getColor(value) {
      //value from 0 to 1
      const hue = ((1-value)*120).toString(10);
      return ["hsl(",hue,",100%,50%)"].join("");
    },
    processDates(dates) {
      const datesProcessed = [];
      let highestRooms = 0;
      let highestOneRoom = 0;
      let highestTwoRoom = 0;
      let highestThreeRoom = 0;
      let highestChange = 0;
      let highestDeparture = 0;

      const ONE_ROOM_WEIGHT = 0.1;
      const TWO_ROOM_WEIGHT = 0.15;
      const THREE_ROOM_WEIGHT = 0.2;
      const DEPARTURE_WEIGHT = 0.05;
      const CHANGE_WEIGHT = 0.5;

      // Here comes all the logic
      for (let i = 0; i < dates.length; i += 1) {
        const d = dates[i];
        const currentDay = new Date(d.endDate).getDate();
        const currentMonth = new Date(d.endDate).getMonth();
        const currentYear = new Date(d.endDate).getFullYear();

        // We check if the date is unique
        let isDouble = false;
        for (let y = 0; y < datesProcessed.length; y += 1) {
          const d = datesProcessed[y];
          const currentDay2 = new Date(d.date).getDate();
          const currentMonth2 = new Date(d.date).getMonth();
          const currentYear2 = new Date(d.date).getFullYear();

          if (currentDay === currentDay2 && currentMonth === currentMonth2 && currentYear === currentYear2) {
            isDouble = true;
            break;
          }
        }

        if (isDouble) continue;

        const currentDates = dates.filter(d => {
          const day = new Date(d.endDate).getDate();
          const month = new Date(d.endDate).getMonth();
          const year = new Date(d.endDate).getFullYear();
          return day === currentDay && month === currentMonth && year === currentYear;
        });

        let departures = 0;
        let oneRoom = 0;
        let twoRoom = 0;
        let threeRoom = 0;
        let change = 0;

        for (let x = 0; x < currentDates.length; x += 1) {
          departures += 1;
          const currentDate = currentDates[x];
          if (currentDate.rentObject.rooms === 1) {
            oneRoom += 1;
          } else if (currentDate.rentObject.rooms === 2) {
            twoRoom += 1;
          } else if (currentDate.rentObject.rooms === 3) {
            threeRoom += 1;
          }

          if (currentDate.nextBooking && currentDate.nextBooking[0]) {
            let nextDay = new Date(currentDate.nextBooking[0].startDate).getDate();
            let nextMonth = new Date(currentDate.nextBooking[0].startDate).getMonth();
            let nextYear = new Date(currentDate.nextBooking[0].startDate).getFullYear();

            if (nextDay === currentDay && nextMonth === currentMonth && nextYear === currentYear) {
              change += 1;
            }
          }
        }

        if (d.rentObject.rooms > highestRooms) {
          highestRooms = d.rentObject.rooms;
        }

        if (oneRoom > highestOneRoom) {
          highestOneRoom = oneRoom;
        }

        if (twoRoom > highestTwoRoom) {
          highestTwoRoom = twoRoom;
        }

        if (threeRoom > highestThreeRoom) {
          highestThreeRoom = threeRoom;
        }

        if (change > highestChange) {
          highestChange = change;
        }

        if (departures > highestDeparture) {
          highestDeparture = departures;
        }

        datesProcessed.push({
          date: dates[i].endDate,
          departures: departures,
          oneRoom: oneRoom,
          twoRoom: twoRoom,
          threeRoom: threeRoom,
          changes: change,
          score: oneRoom * ONE_ROOM_WEIGHT + twoRoom * TWO_ROOM_WEIGHT + threeRoom * THREE_ROOM_WEIGHT + departures * DEPARTURE_WEIGHT + change * CHANGE_WEIGHT
        });
      }

      return {
        highestRooms: highestRooms,
        highestOneRoom: highestOneRoom,
        highestTwoRoom: highestTwoRoom,
        highestThreeRoom: highestThreeRoom,
        highestChange: highestChange,
        highestDeparture: highestDeparture,
        highestScore: highestRooms * ONE_ROOM_WEIGHT + highestOneRoom * TWO_ROOM_WEIGHT + highestTwoRoom * THREE_ROOM_WEIGHT + highestDeparture * DEPARTURE_WEIGHT + highestChange * CHANGE_WEIGHT,
        datesProcessed: datesProcessed
      };
    }
  },
  async mounted() {
    this.cleaningDates = await this.$store.dispatch("rentObjectBookings/findCleaningDates", this.dateRange);
    this.cleaningDatesProcessed = this.processDates(this.cleaningDates);
  },
}
</script>

<style lang="scss" scoped>
.day {
  display: inline-block;
  width: 120px;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: white;
}
.row {
  display: flex;
  justify-content: space-between;
  &.bold {
    font-weight: 600;
    font-size: 14px;
  }
}
</style>